module.exports = __webpack_public_path__ + "img/linkedin_logo.c1eb2740.svg";